import script from "./PainProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./PainProfile.vue?vue&type=script&setup=true&lang=js"

import "./PainProfile.vue?vue&type=style&index=0&id=fe05c3d2&lang=css"

const __exports__ = script;

export default __exports__